<!--  
  报警信息
-->

<template>
  <div class="warning_info">
    <ContentSection
      :title="'报警信息'"
      :mainStyle="{ borderLeftStyle: 'solid', height: '25.617vh' }"
      :position="'right'"
    >
      <div class="warning_main">
        <!-- 列表 -->
        <ul class="content_list">
          <li v-for="(item, index) in contentList" :key="index">
            <!-- 上半部分 -->
            <div class="content_top">
              <div class="warning_title">{{ item.name }}</div>
              <div class="separate"></div>
              <div class="warning_time">{{ item.warningTime }}</div>
            </div>
            <!-- 下半部分内容 -->
            <div class="content_bottom">
              <div class="warning_content">
                报警内容：{{ item.warningContent }}
              </div>
              <img src="@/assets/img/warning_sanjiao.png" />
            </div>
          </li>
        </ul>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from "@/components/ContentSection";
import {getAlarm} from "@/api/basic.js"
export default {
  name: "warningInfo",
  components: {
    ContentSection,
  },
  data() {
    return {
      // 列表数据
      contentList: [
        {
          name: "水位监测点01",
          warningTime: "09:42:42/2022.10.13",
          warningContent: "水位过高，超过预警值",
        },
        {
          name: "水位监测点01",
          warningTime: "09:42:42/2022.10.13",
          warningContent: "水位过高，超过预警值",
        },
        {
          name: "水位监测点01",
          warningTime: "09:42:42/2022.10.13",
          warningContent: "水位过高，超过预警值",
        },
        {
          name: "水位监测点01",
          warningTime: "09:42:42/2022.10.13",
          warningContent: "水位过高，超过预警值",
        },
        {
          name: "水位监测点01",
          warningTime: "09:42:42/2022.10.13",
          warningContent: "水位过高，超过预警值",
        },
      ],
    };
  },
  mounted(){
    this.setData()
  },
  methods:{
    setData(){
      let date = this.$formatDate(new Date())
      let data ={
        starttime:date.year +' '+'00:00:00',
        endtime:date.year +' '+date.hours
      }
      getAlarm(data).then(res=>{
        if(res.errorcode == 0){
          // console.log(res)
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.warning_info {
  .warning_main {
    width: 100%;
    height: 100%;
    display: flex;
    // 列表
    .content_list {
      width: 834px;
      height: 787vh * @vh;
      margin: auto;
      // overflow-y: scroll;
      font-size: 24px;
      color: #80c7ff;
      li {
        width: 834px;
        height: 146vh * @vh;
        background-color: rgba(0, 0, 0, 0.2);
        margin-bottom: 13vh * @vh;
        border-radius: 6vw * @vw;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        & > div {
          width: 805px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        // 上半部分内容
        .content_top {
          // 标题
          .warning_title {
            width: 214px;
            min-height: 44vh * @vh;
            background-image: url("@/assets/img/warning_title_back.png");
            background-size: 100% 100%;
            font-size: 30px;
            font-family: PMZ;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            /*文字超出宽度则显示ellipsis省略号*/
            text-overflow: ellipsis;
            &:hover{
              width: auto;
              // text-overflow: inherit;
              // overflow: visible;
              // white-space: pre-line;
            }
          }
          // 分隔线
          .separate {
            width: 217px;
            height: 1px;
            border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
            position: relative;
            &::before {
              content: "";
              display: block;
              width: 6vw * @vw;
              height: 6vw * @vw;
              background: #fff;
              border-radius: 50%;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translate(-50%);
            }
          }
        }
        // 下半部分内容
        .content_bottom {
          img {
            width: 14px;
            height: 19vh * @vh;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
.warning_info {
  .warning_main {
    // 列表
    .content_list {
      width: 634px;
      height: 787vh * @vh;
      margin: auto;
      // overflow-y: scroll;
      font-size: 24px;
      color: #80c7ff;
      li {
        width: 634px;
        height: 146vh * @vh;
        background-color: rgba(0, 0, 0, 0.2);
        margin-bottom: 13vh * @vh;
        border-radius: 6vw * @vw;
        & > div {
          width: 615px;
        }
        // 上半部分内容
        .content_top {
          // 标题
          .warning_title {
            width: 214px;
            min-height: 44vh * @vh;
            font-size: 24px;
            &:hover{
              width: auto;
              // text-overflow: inherit;
              // overflow: visible;
              // white-space: pre-line;
            }
          }
          // 分隔线
          .separate {
            width: 157px;
            height: 1px;
          }
        }
        // 下半部分内容
        .content_bottom {
          img {
            width: 14px;
            height: 19vh * @vh;
          }
        }
      }
    }
  }
}
}
</style>